<template>
    <div id="appointment-list">
        <div class="row topactionform">
            <div class="col-xs-4" style="padding-right: 0">
                <div class="smalltitle">List {{getPageName}}</div>
            </div>
            <div class="col-xs-8">
                <form class="onelineform flowsearch" @submit.prevent="filterDoctor">
                    <button type="submit" class="submit btn light" style="float: right; width: 10%"><i
                            class="fa fa-search"></i></button>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select v-model="formSearch.status" @change="filterDoctor">
                            <option value="">Account status</option>
                            <option :value="STATUS_ACTIVE">Activated</option>
                            <option value="0">Deactivated</option>
                        </select>
                    </span>
                    <input type="text" placeholder="Name or leave blank for search all"
                           v-model="formSearch.keySearch"
                           class="keyinput" style="width: 35%; border-left: 1px solid #e1e1e1; float: right">
                </form>
            </div>
        </div>
        <div class="blockcont">
            <ul class="itemlisttable  ptemr-list">
                <li class="itemlisthead">
                    <div class="item-name">Full Name</div>
                    <div class="item-created-at">Created</div>
                    <div class="item-member group-member-column">Member</div>
                    <div class="item-account-status">Account status</div>
                    <div class="item-account-status">Email status</div>
                    <div class="item-account-status">Event Function</div>
                    <div class="item-emr-status">EMR status</div>
                    <div class="item-action">Action</div>
                </li>
                <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i
                        class="fas fa-spinner fa-spin"></i></li>
                <li v-if="!isLoading && dataDoctors.length === 0" style="text-align: center; font-size: 16pt">
                    No records found
                </li>
                <li v-if="!isLoading" class="item-doctor" v-for="(doctor, index) in dataDoctors">
                    <div class="item-name">
                        <span class="item-folder" :class="{'opened': doctor.opened}"
                              @click="showListMember(doctor)"></span>
                        <span @click="showDetailUser(doctor)">
                             <div class="avatar-user"
                                  :style="'background-image: url('+doctor.avatar+')'"></div>
                        {{doctor.fullName}}
                        </span>

                    </div>
                    <div class="item-created-at">{{formatTime(doctor.createdAt)}}</div>
                    <div class="item-member group-member-column">N/A</div>
                    <div class="item-account-status">{{getStatusText(doctor.status)}}</div>
                    <div class="item-account-status">N/A</div>
                    <div class="item-account-status">N/A</div>
                    <div class="item-emr-status">{{getStatusText(doctor.emr_status)}}</div>
                    <div class="item-action itemaction group-actions">
                        <div class="btn-group dropdown" v-if="typePage === 'LIST_GROUP'">
                            <a href="javascript:void(0)" @click.prevent="showModalWikiPackage(doctor)">
                                <i class="fa fa-list-alt"></i> Wiki Package
                            </a>
                        </div>
                        <dropdown class="group-settings">
                            <a href="javascript:void(0)" title="Action" data-toggle="dropdown">
                                <i class="fa fa-cog"
                                   aria-hidden="true"></i></a>
                            <template slot="dropdown">
                                <div>
                                    <a :href="getLinkProfileAccount(doctor.id)" target="_blank">Profile</a>
                                </div>
                                <div>
                                    <a href="javascript:void(0)"
                                        @click.prevent="changeStatusAccount(doctor)">{{getStatusAccountAction(doctor)}}</a>
                                </div>
                                <div>
                                    <a href="javascript:void(0)"
                                        @click.prevent="changeStatusEmr(doctor)">{{getStatusEmrAction(doctor)}}</a>
                                </div>
                                <div>
                                    <a href="javascript:void(0)" @click.prevent="addMember(doctor)">Add Member</a>
                                </div>
                              <div><a href="javascript:void(0)"
                                      @click.prevent="showModalSetNewPassword(doctor)">Set new password</a>
                              </div>
                            </template>
                        </dropdown>
                    </div>
                    <div class="itemlisttable  list-members" v-if="doctor.opened">

                        <div class="itemlisthead">
                            <div class="item-sub-member">Members</div>
                            <div class="item-sub-date">Date</div>
                            <div class="item-sub-plan">Plan</div>
                            <div class="item-sub-contact">Contact</div>
                            <div class="item-sub-fee">Fee</div>
                            <div class="item-sub-dob">DOB</div>
                            <div class="item-sub-create">Created At</div>
                            <div class="item-sub-action itemaction">Action</div>
                            <div class="clearfix"></div>
                        </div>
                        <div v-if="doctor.isLoading" style="text-align: center; color: #d9df20;"><i
                                class="fas fa-spinner fa-spin"></i></div>
                        <div v-if="!doctor.isLoading && doctor.listMember.length === 0" style="text-align: center;">
                            No records found
                        </div>
                        <div class="item-member" v-for="(member, index) in doctor.listMember">
                            <div class="item-sub-member">
                               <span @click="showDetailUser(member)" style="padding-right: 5px">
                                   <div class="avatar-user" :style="'background-image: url('+member.avatar+')'"></div>
                                </span>

                                <strong>{{member.fullName}}</strong>
                                <div style="padding-left: 25px;" class="position red" v-if="member.type == 2">
                                    Board member <span v-if="member.status == 0"> - Deactivated</span></div>
                                <div style="padding-left: 25px;" class="position" v-if="member.type == 1">
                                    General member <span class="red" v-if="member.status == 0"> - Deactivated</span>
                                </div>

                            </div>
                            <div class="item-sub-date">
                                  <span v-if="member.status === 2">
                                    <span>{{formatTime(member.joined_day)}}</span>
                                    <span class="position" style="display: block;">Confirmed</span>
                                </span>
                                <span v-if="member.status == 1">
                                    <span>{{member.added}}</span>
                                     <span class="position" style="display: block;font-style: italic;">Waitting</span>
                                </span>
                                <span v-if="member.status != 2 && member.status != 1">
                                    <span>{{member.added}}</span>
                                     <span class="position" style="display: block;font-style: italic;">Added</span>
                                </span>

                            </div>
                            <div class="item-sub-plan">{{member.membership_plan}}</div>
                            <div class="item-sub-contact">{{member.email_phone_active}}</div>
                            <div class="item-sub-fee">{{member.amount}}</div>
                            <div class="item-sub-dob">{{formatTime(member.birthDay)}}</div>
                            <div class="item-sub-create">{{formatTime(member.createdAt)}}</div>
                            <div class="item-sub-action itemaction">

                                <dropdown v-if="member.status == 1">
                                    <a href="javascript:void(0)" title="Action" data-toggle="dropdown">
                                        <i class="fa fa-cog"
                                           aria-hidden="true"></i></a>
                                    <template slot="dropdown" >
                                        <div ><a href="javascript:void(0)"
                                                                          @click.prevent="confirmMemberGroup(doctor, member)">Confirm member</a>
                                        </div>
                                    </template>
                                </dropdown>

                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div style="    padding-left: 33px;">
                            <pagination v-if="doctor.listMember.length" :currentPage="doctor.paginate.page"
                                        :perPage="doctor.paginate.perPage"
                                        @updatePerPage="updatePerPageDoctor($event, doctor)"
                                        :totalPages="doctor.paginate.totalPages" :total="doctor.paginate.total">
                            </pagination>
                            <div class="clearfix"></div>
                        </div>

                    </div>
                    <div class="clearfix"></div>
                </li>
            </ul>
        </div>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total">
        </pagination>

        <detail-clinic
                v-if="detailClinic.modal"
                :user="detailClinic.user"
                @updateModal="detailClinic.modal = $event"
        >
        </detail-clinic>

        <detail-group
                v-if="detailGroup.modal"
                :user="detailGroup.user"
                @updateModal="detailGroup.modal = $event"
        >
        </detail-group>
        <detail-regular-user
                v-if="detailRegular.modal"
                :user="detailRegular.user"
                @updateModal="detailRegular.modal = $event"
        >
        </detail-regular-user>

        <detail-doctor
                v-if="detailDoctor.modal"
                :user="detailDoctor.user"
                @updateModal="detailDoctor.modal = $event"
        >
        </detail-doctor>
        <add-member-modal
                v-if="dataMember.modal"
                :group="dataMember.group"
                @updateModal="dataMember.modal = $event"
                @addMemberGroup="addNewMemberGroup"
        >
        </add-member-modal>
      <set-new-password v-if="dataNewPassword.modal"
                        @updateModal="dataNewPassword.modal = $event"
                        :user="dataNewPassword.user"
      >
      </set-new-password>
        <order-package-wiki-modal
                v-if="wikiPackageData.modal"
                @updateModal="wikiPackageData.modal = $event"
                :group="wikiPackageData.group">
        </order-package-wiki-modal>
    </div>
</template>

<script>
import Pagination from '../../global/Pagination.vue'
import axios from '../../client'
import CommonMixin from '../../mixins/general/CommonMixin.vue'
import TimeMixin from '../../mixins/general/TimeMixin.vue'
import UserStatusMixin from '../../mixins/user/UserStatusMixin.vue'

const DetailClinic = () => import('./part/DetailClinic')
const DetailGroup = () => import('./part/DetailGroup')
const DetailRegularUser = () => import('./part/DetailRegularUser')
const DetailDoctor = () => import('./part/DetailDoctor')
const AddMemberModal = () => import('./part/AddMemberModal')
const SetNewPassword = () => import('./part/SetNewPassword')
const OrderPackageWikiModal = () => import('./part/OrderPackageWikiModal.vue')
export default {
  name: 'Clinic',
  components: {
    Pagination,
    DetailClinic,
    DetailGroup,
    DetailRegularUser,
    DetailDoctor,
    AddMemberModal,
    SetNewPassword,
    OrderPackageWikiModal
  },
  mixins: [CommonMixin, TimeMixin, UserStatusMixin],
  data () {
    return {
      typePage: 'LIST_CLINIC',
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      dataDoctors: [],
      formSearch: {
        keySearch: '',
        status: ''
      },
      detailClinic: {
        modal: false,
        user: {}
      },
      detailGroup: {
        modal: false,
        user: {}
      },
      detailRegular: {
        modal: false,
        user: {}
      },
      detailDoctor: {
        modal: false,
        user: {}
      },
      processingConfirm: false,
      dataMember: {
        modal: false,
        group: null
      },
      dataNewPassword: {
        modal: false,
        user: {}
      },
      wikiPackageData: {
        modal: false,
        group: {}
      }
    }
  },
  computed: {
    getPageName () {
      if (this.typePage === 'LIST_GROUP') {
        return 'Group'
      }
      return 'Clinic'
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    if (this.$route.name === 'list-group') {
      this.typePage = 'LIST_GROUP'
    }
    this.loadListDoctor()
  },
  beforeDestroy () {
  },
  methods: {
    showModalSetNewPassword (doctor) {
      this.dataNewPassword.modal = true
      this.dataNewPassword.user = doctor
    },
    showModalWikiPackage (group) {
      this.wikiPackageData.modal = true
      this.wikiPackageData.group = group
    },
    addNewMemberGroup () {
      this.loadListMember(this.dataMember.group)
    },
    addMember (doctor) {
      this.dataMember.group = doctor
      this.dataMember.modal = true
    },
    async confirmMemberGroup (doctor, member) {
      if (this.processingConfirm) {
        return
      }
      try {
        let data = {
          memberId: member.id,
          groupId: doctor.id
        }
        this.processingConfirm = true
        let response = await axios.post('/users/confirm-member-group', data)
        this.processingConfirm = false
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          return
        }
        member.status = 2
        member.joined_day = new Date()
        this.$forceUpdate()
        this.alertSuccess(response.data.msg)
      } catch (e) {
        this.processingConfirm = false
        this.alertError(e.message)
      }
    },
    // list member
    showListMember (doctor) {
      doctor.opened = !doctor.opened
      doctor.paginate = this.$options.data().paginate
      this.loadListMember(doctor)
    },
    updatePerPageDoctor (data, doctor) {
      doctor.paginate.perPage = data.perPage
      doctor.paginate.page = data.currentPage
      this.loadListMember(doctor)
    },
    async loadListMember (doctor) {
      if (doctor.isLoading) {
        return
      }
      let params = {
        page: doctor.paginate.page,
        perPage: doctor.paginate.perPage,
        userId: doctor.id
      }
      doctor.isLoading = true
      let response = await axios.get(`/users/list-member-group`, { params: params })
      doctor.isLoading = false
      try {
        if (response.data.s === 200) {
          let dataDoctors = response.data.data.members ? response.data.data.members : []
          doctor.listMember = dataDoctors
          doctor.paginate.page = Number(response.data.data.currentPage)
          doctor.paginate.total = response.data.data.total
          doctor.paginate.totalPages = Math.ceil(doctor.paginate.total / doctor.paginate.perPage)
        } else {
          this.alertError('Server error when load member. F5 and refresh browser')
        }
      } catch (e) {
        doctor.isLoading = false
      }
    },

    // end list member
    showDetailUser (user) {
      if (user.role === 'AllergyClinic') {
        this.detailClinic.modal = true
        this.detailClinic.user = user
      }
      if (user.role === 'group') {
        this.detailGroup.modal = true
        this.detailGroup.user = user
      }
      if (user.role === 'RegularUser') {
        this.detailRegular.modal = true
        this.detailRegular.user = user
      }
      if (['physician', 'allergist'].indexOf(user.role) > -1) {
        this.detailDoctor.modal = true
        this.detailDoctor.user = user
      }
    },
    filterDoctor () {
      this.paginate.page = 1
      this.loadListDoctor()
    },

    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadListDoctor()
    },
    async loadListDoctor () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch,
        status: this.formSearch.status,
        typePage: this.typePage
      }
      let response = await axios.get(`/users/list`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          let dataDoctors = response.data.data.users ? response.data.data.users : []
          dataDoctors.map(item => {
            item.opened = false
            item.paginate = {
              perPage: 10,
              page: 1,
              totalPages: 10,
              total: 0
            }
            item.listMember = []
            item.isLoading = false
            return item
          })
          this.dataDoctors = dataDoctors
          this.paginate.page = Number(response.data.data.currentPage)
          this.paginate.total = response.data.data.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    }
  }
}
</script>
<style>

</style>
<style scoped="">
    .avatar-user {
        width: 20px !important;
        padding-bottom: 20px !important;
        display: inline-block !important;
        border-radius: 50% !important;
        vertical-align: middle !important;
        background-size: cover;
        background-position: top center;
        height: 0;
        background-color: #e1e1e1;
        overflow: hidden;
    }

    .item-name {
        width: 15% !important;
        min-height: 1px;
        cursor: pointer;
        float: left;
    }

    .item-folder:before {
        content: "\f07b";
        font-family: "Font Awesome\ 5 Free";
        color: #faaf3a;
        font-weight: 900;
        font-size: 16px;
        margin-right: 5px;
        cursor: pointer;
    }

    .item-folder.opened:before {
        content: "\f07c" !important;
    }

    .item-dob {
        width: 10% !important;
        min-height: 1px;
        float: left;
    }

    .item-created-at {
        width: 15% !important;
        float: left;
    }

    .item-account-status {
        width: 10% !important;
        text-align: center !important;
    }

    .item-emr-status {
        width: 10% !important;
        text-align: center !important;
    }

    .item-action {
        width: 10% !important;
        float: right;
        min-height: 1px;
        padding-right: 10px;
    }

    .group-member-column {
        width: 20% !important;
    }

    .group-actions {
        display: grid;
        grid-template-columns: max-content max-content;
        justify-content: end;
        align-items: start;
        column-gap: 10px;
        text-align: left !important;
    }

    .group-actions > .btn-group {
        grid-column: 1;
        white-space: nowrap;
    }

    .group-actions > .group-settings {
        grid-column: 2;
        grid-row: 1;
    }

    .onelineform {
        border-left: none !important;
    }

    .list-members {
        width: 100%;
        clear: both;
    }

    .list-members .item-name {
        padding-left: 33px !important;
    }

    .item-member {
        background: inherit !important;

        border-bottom: none !important;
        padding-top: 5px !important;
        vertical-align: top;
    }

    .itemlisttable > div.itemlisthead {
        vertical-align: top;
        padding: 10px 0;
        border-bottom: 1px solid #e1e1e1;
        background: inherit !important;
    }

    .item-sub-member {
        width: 20% !important;
        min-height: 1px !important;
        float: left;
    }

    .item-sub-date {
        width: 10% !important;
        text-align: center !important;
        min-height: 1px !important;
        float: left;
    }

    .item-sub-plan {
        width: 20% !important;
        text-align: center !important;
        min-height: 1px !important;
        float: left;
    }

    .item-sub-contact {
        width: 23% !important;
        text-align: center !important;
        min-height: 1px !important;
        float: left;
    }

    .item-sub-fee {
        width: 8% !important;
        text-align: center !important;
        min-height: 1px !important;
        float: left;
    }

    .item-sub-action {
        width: 5% !important;
        min-height: 1px !important;
        float: right;
        padding-right: 10px;
    }

    .item-sub-dob {
        width: 6% !important;
        text-align: center !important;
        min-height: 1px !important;
        float: left;
    }

    .item-sub-create {
        width: 6% !important;
        text-align: center !important;
        min-height: 1px !important;
        float: left;
    }
</style>
